import React from "react"
import Image from "./../image"

class WhatsPicks extends React.Component {
  render() {
    return (
      <div className="whats-picks">
        <div data-aos="fade-up" className="has-text-centered">
          <h2 className="title is-2 mb-0">WHAT'S PICKS</h2>
          <small className="has-text-grey-light">
            Picksが従来のテイクアウトと違うところ
          </small>
        </div>
        <div>
          <div className="container is-slim">
            <div className="columns is-vcentered">
              <div className="column is-relative has-text-centered">
                <div data-aos="fade-up" className="image">
                  <Image filename="index/whats-picks-1.png" />
                </div>
                <div
                  data-anchor-id="whats-picks-1-above"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  className="image is-above"
                >
                  <Image filename="index/whats-picks-1-above.png" />
                </div>
              </div>
              <div className="column">
                <div data-aos="fade-up">
                  <h3 className="title is-3">
                    テイクアウトできる
                    <br />
                    お店が簡単に見つかる
                  </h3>
                </div>
                <div data-aos="fade-up">
                  <div className="text mt-20">
                    Picksなら現在地から近くのテイクアウトできる
                    レストランを簡単に見つけることができます。
                    <br />
                    テイクアウト専門店はもちろん、いつも並んでいて
                    入りづらい有名店など様々なお店が登録されています。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="container is-slim">
            <div className="columns is-vcentered reverse-row-order">
              <div className="column is-relative has-text-centered">
                <div data-aos="fade-up" className="image">
                  <Image filename="index/whats-picks-2.png" />
                </div>
                <div
                  data-aos="fade-up"
                  data-aos-delay="200"
                  className="image is-above"
                >
                  <Image filename="index/whats-picks-2-above.png" />
                </div>
              </div>
              <div className="column">
                <div data-aos="fade-up">
                  <h3 className="title is-3">スマホ1つで簡単に注文できる！</h3>
                </div>
                <div data-aos="fade-up">
                  <div className="text mt-20">
                    電話不要！スマートフォンアプリまたはWEBサイトから簡単に注文することができます。
                    だから、通勤途中や仕事の合間のスキマ時間に注文することができます。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="container is-slim">
            <div className="columns is-vcentered">
              <div className="column is-relative has-text-centered">
                <div data-aos="fade-up" className="image">
                  <Image filename="index/whats-picks-3.png" />
                </div>
                <div
                  data-aos="fade-up"
                  data-aos-delay="200"
                  className="image is-above"
                >
                  <Image filename="index/whats-picks-3-above.png" />
                </div>
              </div>
              <div className="column">
                <div data-aos="fade-up">
                  <h3 className="title is-3">お店で待たなくてOK</h3>
                </div>
                <div data-aos="fade-up">
                  <div className="text mt-20">
                    調理が完了したらスマーフォンのプッシュ通知やメールで通知が届きます。
                    調理が完了したらお店に向かってすぐに料理を受け取れるのでわざわざお店で待つ必要はありません。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="container is-slim">
            <div className="columns is-vcentered reverse-row-order">
              <div className="column is-relative has-text-centered">
                <div data-aos="fade-up" className="image">
                  <Image filename="index/whats-picks-4.png" />
                </div>
                <div
                  data-aos="fade-up"
                  data-aos-delay="200"
                  className="image is-above"
                >
                  <Image filename="index/whats-picks-4-above.png" />
                </div>
              </div>
              <div className="column">
                <div data-aos="fade-up">
                  <h3 className="title is-3">
                    テイクアウトをより楽しく、より日常的に
                  </h3>
                </div>
                <div data-aos="fade-up">
                  <div className="text mt-20">
                    Picksに新規会員登録すると、月々の利用金額に応じてRewards Clubに入ることができます。
                    Rewards Clubに入ると、Picksでの注文ごとにポイントが還元されます！
                    貯まったポイントはクーポンに交換して、次回の注文時に利用できるようになります。使えば使うほど還元率も上がるので、毎日の食事をテイクアウトでもっと楽しく。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default WhatsPicks
